import waypoint from 'waypoints/lib/jquery.waypoints.min.js' // eslint-disable-line no-unused-vars
import flickity from 'flickity/dist/flickity.pkgd.min.js'; // eslint-disable-line no-unused-vars
import flickityfade from 'flickity-fade/flickity-fade.js'; // eslint-disable-line no-unused-vars
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js'; // eslint-disable-line no-unused-vars
import isotope from 'isotope-layout/dist/isotope.pkgd.min.js'; // eslint-disable-line no-unused-vars
import Cookies from 'js-cookie/src/js.cookie.js'; // eslint-disable-line no-unused-vars

export default {
  init() {
    // JavaScript to be fired on all pages
    $('a#click-a').on('click', function(){
      $(this).toggleClass('open');
      $('body').toggleClass('menu-open');

      $('.feature-image').each(function(){
        let feature = $(this).attr('data-src');
        $(this).css('background-image', 'url(' + feature + ')');
      });

      $('#menu-hauptmenue > li > a, #menu-hauptmenue-englisch > li > a').on('mouseenter', function(){
        let target = $(this).attr('data-target');
        $('.' + target).css('opacity', '0.2');
      });

      $('#menu-hauptmenue > li > a, #menu-hauptmenue-englisch > li > a').on('mouseleave', function(){
        let target = $(this).attr('data-target');
        $('.' + target).css('opacity', '1');
      });
    });

    if ($('.wpml-ls-item').length){
      $('.wpml-ls-item a span').each(function(){
          var $langArray = $(this).html().split('');
          //console.log($langArray);
          $(this).parent().show('slow');
          $(this).html($langArray[0] + $langArray[1]);
          
      });
    }

    $('.button.anfrage-1').on('click', function(){
      $('.anfrage-wrapper').fadeIn();
      $('body').addClass('anfrage-open');
    });

    $('.button-close-wrapper button').on('click', function(){
      $('.anfrage-wrapper').fadeOut();
      $('body').removeClass('anfrage-open');
    });

    $(document).ready(function(){
        $('body').removeClass('fade-out');

        var fadeIn = $('.fader').waypoint({ // eslint-disable-line no-unused-vars
          handler: function() {
            $(this.element).addClass('fadeInUp');
            $('.fader').css('opacity', 'initial');
          },
          offset: '100%',
        });

        var resizing = false;

        $(window).resize( function() {
          resizing = true;
        });

        setInterval( function() {
          if ( resizing ) {
            resizing = false;
            setGuestbookSlider();
          }
        }, 250 );

    
        if(Cookies.get('wp-wpml_current_language') == 'en') {
          $('.acf-field-date-picker.arrival input.hasDatepicker').attr( 'placeholder', 'Arrival*' );
          $('.acf-field-date-picker.departure input.hasDatepicker').attr( 'placeholder', 'Departure*' );
          $('#acf-field_anfrage_personen').attr( 'placeholder', 'Persons*' );
          $('#acf-field_anfrage_anrede[value=herr]').parent().html( '<input type="radio" id="acf-field_anfrage_anrede" name="acf[field_anfrage_anrede]" value="herr" checked="checked">Mr.');
          $('#acf-field_anfrage_anrede-frau').parent().html( '<input type="radio" id="acf-field_anfrage_anrede-frau" name="acf[field_anfrage_anrede]" value="frau">Mrs.');
          $('#acf-field_anfrage_name').attr( 'placeholder', 'Name*' );
          $('#acf-field_anfrage_vorname').attr( 'placeholder', 'First Name*' );
          $('#acf-field_anfrage_e-mail').attr( 'placeholder', 'Email*' );
          $('#acf-field_anfrage_telefon').attr( 'placeholder', 'Phone*' );
          $('#acf-field_anfrage_nachricht').attr( 'placeholder', 'Message*');
          $('#acf-field_anfrage_call-ja').parent().html( '<input type="checkbox" id="acf-field_anfrage_call-ja" name="acf[field_anfrage_call][]" value="ja"> I ask for a call back');
          $('#acf-field_anfrage_terms-ja').parent().html( '<input type="checkbox" id="acf-field_anfrage_terms-ja" name="acf[field_anfrage_terms][]" value="ja"> I accept the Privacy Policy*');
          $('#acf-field_anfrage_zimmertyp option[value=doppelzimmer]').html('Double Room*');
          $('#acf-field_anfrage_zimmertyp option[value=juniorsuite]').html('Junior Suite*');
          $('#acf-field_anfrage_zimmertyp option[value=misc]').html('Various*');
          $('#acf-field_anfrage_zimmertyp option:first-of-type').html('Please Select Your Room*');

          //Coupon Form
          $('#acf-field_coupon_data_anrede[value=herr]').parent().html( '<input type="radio" id="acf-field_coupon_data_anrede" name="acf[field_coupon_data_anrede]" value="mr." checked="checked">Mr.');
          $('#acf-field_coupon_data_anrede-frau').parent().html( '<input type="radio" id="acf-field_coupon_data_anrede-frau" name="acf[field_coupon_data_anrede]" value="mrs.">Mrs.');
          $('#acf-field_coupon_data_amount').attr( 'placeholder', 'Value of the voucher (in €)*' );
          $('#acf-field_coupon_data_receiver').attr( 'placeholder', 'Who is the voucher for?*' );
          $('#acf-field_coupon_data_delivery[value=pickup]').parent().html( '<input type="radio" id="acf-field_coupon_data_delivery" name="acf[field_coupon_data_delivery]" value="pickup" checked="checked">I will pick up the voucher directly at the hotel.');
          $('#acf-field_coupon_data_delivery-deliver').parent().html( '<input type="radio" id="acf-field_coupon_data_delivery-deliver" name="acf[field_coupon_data_delivery]" value="deliver">Please send me the voucher by mail free of charge.');
          $('.acf-field-coupon-data-billing-message h2').html( 'Bill recipient' );
          $('#acf-field_coupon_data_name').attr( 'placeholder', 'Last Name*' );
          $('#acf-field_coupon_data_vorname').attr( 'placeholder', 'First Name*' );
          $('#acf-field_coupon_data_email').attr( 'placeholder', 'Email*' );
          $('#acf-field_coupon_data_street').attr( 'placeholder', 'Street, house number*' );
          $('#acf-field_coupon_data_zip').attr( 'placeholder', 'Post Code*');
          $('#acf-field_coupon_data_note').attr( 'placeholder', 'Note');
          $('#acf-field_coupon_data_place').attr( 'placeholder', 'City*');
          $('#acf-field_coupon_data_country').attr( 'placeholder', 'Country*');
          $('#acf-field_coupon_data_company').attr( 'placeholder', 'Company');
          $('#acf-field_coupon_data_zip').attr( 'placeholder', 'Post Code*');
          $('#acf-field_coupon_confirm_terms-ja').parent().html( '<input type="checkbox" id="acf-field_coupon_confirm_terms-ja" name="acf[field_coupon_confirm_terms][]" value="ja"> I confirm the accuracy of the information provided and have read and accept the terms and conditions and the data protection provisions.*');
        }else{
          // add the placeholder
         $('.acf-field-date-picker.arrival input.hasDatepicker').attr( 'placeholder', 'Anreise*' ); 
         $('.acf-field-date-picker.departure input.hasDatepicker').attr( 'placeholder', 'Abreise*' );
        }

      

      var options = {
        prevNextButtons: false,
        wrapAround: false,
        imagesLoaded: true,
        pageDots: false,
        fade: true,
        lazyLoad: 1,
        autoPlay: 4000,
        cellSelector: '.slide',
        draggable: true,
        pauseAutoPlayOnHover: false,
      };

      var optionsHero = {
        prevNextButtons: true,
        wrapAround: true,
        imagesLoaded: true,
        pageDots: false,
        fade: false,
        lazyLoad: 1,
        autoPlay: 4000,
        cellSelector: '.slide',
        draggable: true,
        pauseAutoPlayOnHover: false,
        arrowShape: { 
          x0: 25,
          x1: 70, y1: 50,
          x2: 75, y2: 50,
          x3: 30,
        },
      };

      var optionsGuestbook = {
        prevNextButtons: true,
        wrapAround: true,
        imagesLoaded: true,
        pageDots: false,
        autoPlay: false,
        cellSelector: '.slide',
        draggable: true,
        initialIndex: '.is-initial-select',
        pauseAutoPlayOnHover: false,
        arrowShape: { 
          x0: 25,
          x1: 70, y1: 50,
          x2: 75, y2: 50,
          x3: 30,
        },
      };

      var optionsGuestbookMobile = {
        prevNextButtons: false,
        wrapAround: true,
        imagesLoaded: true,
        pageDots: false,
        autoPlay: 5000,
        cellSelector: '.slide',
        draggable: true,
        initialIndex: '.is-initial-select',
        pauseAutoPlayOnHover: false,
      };
  
      var carouselPreview = $('.unterseiten .slider-wrapper, .introdouble .slider-wrapper').flickity(options); // eslint-disable-line no-unused-vars
      var carouselHero = $('.vollbildintro .slider-wrapper').flickity(optionsHero); // eslint-disable-line no-unused-vars
      
      var carouselGuestbook; // eslint-disable-line no-unused-vars
      var isFlickity = false; // eslint-disable-line no-unused-vars

      function setGuestbookSlider() {
        //console.log($(window).width());
        if ($(window).width() > 767) {
          console.log(isFlickity);
          if (isFlickity) {
            carouselGuestbook.flickity('destroy');
          }
          carouselGuestbook = $('.slider-wrapper.guestbook-slider').flickity(optionsGuestbook);
          isFlickity = true;
        } else {
          console.log(isFlickity);
          if (isFlickity) {
            carouselGuestbook.flickity('destroy');
          }
          carouselGuestbook = $('.slider-wrapper.guestbook-slider').flickity(optionsGuestbookMobile);
          isFlickity = true;
        }
      }

      setGuestbookSlider();

      //var flktyJumbo = $(carouselPreview).data('flickity'); // eslint-disable-line no-unused-vars

      var offsetTrigger = '110%';
      var lazyEl = $('.lazy').waypoint({ // eslint-disable-line no-unused-vars
        handler: function() {
          if ($(this.element).hasClass('bottomview')) {
            offsetTrigger = 'bottom-in-view';
          }
          $(this.element).attr('srcset', $(this.element).attr('data-srcset'));
          $(this.element).attr('src', $(this.element).attr('data-src')).animate({
            opacity: 1,
          }, 400, function() {
            // Animation complete.
            $(this).removeAttr('data-srcset');
            $(this).removeAttr('data-src');
            $(this).removeClass('lazy');
            $eventgrid.isotope();
          });
        },
        offset: offsetTrigger,
      });

      var $speisekarte = $('.speisekarte-slider').flickity({
        prevNextButtons: false,
        pageDots: false,
        fade: true,
        draggable: false,
      });
      // Flickity instance
      var flkty = $speisekarte.data('flickity');
      // elements
      var $cellButtonGroup = $('.button-group--cells');
      var $cellButtons = $cellButtonGroup.find('.button');
      
      // update selected cellButtons
      $speisekarte.on( 'select.flickity', function() {
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
      });
      
      // select cell on button click
      $cellButtonGroup.on( 'click', '.button', function() {
        var index = $(this).index();
        $speisekarte.flickity( 'select', index );
      });

      $('.button-group--cells .button:first').addClass('is-selected');

      var $eventgrid = $('.veranstaltungen-grid');

      $(window).load(function() {
        $eventgrid.isotope({
          // options
          layoutMode: 'masonry',
          itemSelector: '.event-item',
        });
      });

      $('.event-item .collapse-icon, .event-item h2, .event-item img').on('click', function(){
        setTimeout(function(){
          $eventgrid.isotope();
        }, 400);
      });

      $('.event-item a.button').on('click', function(){
        let id = $(this).attr('data-id');
        let text = $(this).attr('data-text');
        $('#acf-field_anfrage_anfrage_event').append(new Option(text, id));
        $('#acf-field_anfrage_anfrage_event').val(id).change();
      });

      // bind filter button click
      $('.filter-entries').on( 'click', 'button', function() {
        var filterValue = $( this ).attr('data-filter');
        // use filterFn if matches value
        //filterValue = filterFns[ filterValue ] || filterValue;
        $eventgrid.isotope({ filter: filterValue });
      });
      // change is-checked class on buttons
      $('.filter-entries').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
        $buttonGroup.on( 'click', 'button', function() {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $( this ).addClass('is-checked');
        });
      });

      /*var waypoint = new Waypoint({ // eslint-disable-line no-unused-vars
        element: document.getElementsByClassName('lazy'),
        handler: function() {
          $(this.element).attr('src', $(this.element).attr('data-src'));
          $(this.element).attr('srcset', $(this.element).attr('data-srcset'));
        },
        offset: '100%',
      });*/
    });

    $(window).load(function(){
      Waypoint.refreshAll(); // eslint-disable-line
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js